import React from 'react';
import SilverButton from "./SilverButton";
import LoadingComponent from "../../components-new/ui/LoadingComponent";
import colors from "../../utils/Colors";
import Colors from "../../utils/Colors";
import ExcelIcon from "../../assets/icons/ExcelIcon";

const ExcelButton = ({
                         onClick,
                         alt = 'Export',
                         height = 40,
                         width = 40,
                         children,
                         variant = 'default',
                         disabled = false,
                         loading = false
                     }) => {
    return (
        <SilverButton
            width={width}
            height={height}
            onClick={onClick}
            variant={variant}
            disabled={loading || disabled}
        >
            {
                loading ?
                    <LoadingComponent size={20} style={{color: colors.silverDark}} stroke="currentColor"/>
                    :
                    <div style={{
                        display: 'flex',
                        gap: '10px',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: 'transparent',
                        height: '100%',
                        width: '100%'
                    }}>
                        <ExcelIcon width={24} height={24} style={{color: Colors.silverBlueDark}} stroke="currentColor"/>
                        {children}
                    </div>
            }

        </SilverButton>
    );
};

export default ExcelButton;



// WEBPACK FOOTER //
// ./src/components-new/buttons/ExcelButton.jsx